import React, { useState } from 'react';
import { Globe } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { languageNames } from '../translations/translations';

export const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 text-white/70 hover:text-white transition-colors duration-150"
        data-testid="language-selector-button"
      >
        <Globe weight="duotone" className="text-lg" />
        <span className="hidden sm:inline font-medium">{languageNames[language].split(' ')[0]}</span>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-56 bg-popover backdrop-blur-lg border border-white/10 rounded-sm shadow-xl z-50" data-testid="language-dropdown">
            <div className="py-2">
              {Object.entries(languageNames).map(([code, name]) => (
                <button
                  key={code}
                  onClick={() => handleLanguageChange(code)}
                  className={`w-full px-4 py-2.5 text-left transition-colors duration-150 ${
                    language === code
                      ? 'bg-primary/10 text-primary font-semibold'
                      : 'text-white/70 hover:bg-white/5 hover:text-white'
                  }`}
                  data-testid={`language-option-${code}`}
                >
                  {name}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
